<template>
    <div :key="key.tablero">
        <!--<div
      id="cargando"
      wire:loading
      class="
        fixed
        top-0
        left-0
        right-0
        bottom-0
        w-full
        h-screen
        z-50
        overflow-hidden
        bg-gray-700
        opacity-75
        flex flex-col
        items-center
        justify-center
      "
    >
      <div
        class="
          loader
          ease-linear
          rounded-full
          border-4 border-t-4
          h-12
          w-12
          mb-4
        "
      ></div>
      <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
      <p class="w-1/3 text-center text-white">
        Esto puede tardar unos segundos, no cierre esta página.
      </p>
    </div>-->
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64">

            </v-progress-circular>
        </v-overlay>
        <div class="flex" style="margin-top: 60px">
            <v-chip small :class="'defaultConst--text font-weight-bold mr-2 mr-lg-1 mr-lg-2 my-1 px-2'" label>
                <v-icon left>
                    mdi-database
                </v-icon>Total: {{ this.Total }}
            </v-chip>
            <v-chip small :class="'defaultConst--text font-weight-bold mr-2 mr-lg-1 mr-lg-2 my-1 px-2'" label>{{
                this.seccion }}</v-chip>
            <v-chip v-if="this.busqueda.proceso != ''" small
                :class="'defaultConst--text font-weight-bold mr-2 mr-lg-1 mr-lg-2 my-1 px-2'" label>{{
                    this.busqueda.proceso.PTabNombre }}</v-chip>
            <v-chip v-for="item in this.busqueda.aseguradora" :key="item.clnombre" small
                :class="'defaultConst--text font-weight-bold mr-2 mr-lg-1 mr-lg-2 my-1 px-2'" label>{{ item.clnombre
                }}</v-chip>
            <v-chip v-if="this.busqueda.flotilla != ''" small
                :class="'defaultConst--text font-weight-bold mr-2 mr-lg-1 mr-lg-2 my-1 px-2'" label>{{
                    this.busqueda.flotilla.flnomcorto }}</v-chip>
            <v-chip v-if="this.busqueda.estado != ''" small
                :class="'defaultConst--text font-weight-bold mr-2 mr-lg-1 mr-lg-2 my-1 px-2'" label>{{
                    this.busqueda.estado.esnombre }}</v-chip>
            <v-chip v-if="this.busqueda.gerencia != '' && this.busqueda.gerencia != null" small
                :class="'defaultConst--text font-weight-bold mr-2 mr-lg-1 mr-lg-2 my-1 px-2'" label>{{
                    this.busqueda.gerencia.genombre }}</v-chip>
            <v-chip v-if="this.busqueda.supervisoria != ''" small
                :class="'defaultConst--text font-weight-bold mr-2 mr-lg-1 mr-lg-2 my-1 px-2'" label>{{
                    this.busqueda.supervisoria.sunombre }}</v-chip>
            <v-chip v-if="this.busqueda.abogado != ''" small
                :class="'defaultConst--text font-weight-bold mr-2 mr-lg-1 mr-lg-2 my-1 px-2'" label>{{
                    this.busqueda.abogado.prnombre }}</v-chip>

        </div>
        <div class="flex justify-center">
            <div class="min-h-screen flex  py-12">

            </div>
            <div v-dragscroll="scroll" class="min-h-screen flex overflow-x-scroll py-2">

                <div v-for="columna in tablero" :key="columna.encabezado"
                    :class="{ 'bg-gray-900': theme, 'bg-gray-200': !theme }"
                    class="md:container m-0.5 px-2 py-2 rounded rounded-lg">
                    <p class="text-gray-400 font-semibold font-sans tracking-wide text-sm">
                        {{ columna.encabezado }}
                        <v-chip v-if="obtenerTotal(columna.idColumna) != 0" small :style="bgStyle([83, 103, 254])"
                            :class="'primaryConst--text font-weight-bold mr-2 mr-lg-1 mr-lg-2 my-1 px-2'" label>{{
                                obtenerTotal(columna.idColumna) }}</v-chip>

                    </p>

                    <!-- Draggable component comes from vuedraggable. It provides drag & drop functionality -->
                    <!-- <draggable :list="columna.tarjeta" :animation="200" ghost-class="ghost-card" group="tasks"> -->
                    <!-- Each element from here will be draggable and animated. Note :key is very important here to be unique both for draggable and animations to be smooth & consistent. -->
                    <task-card v-for="tarjeta in columna.tarjeta" :key="tarjeta.ClaveTar" :tarjeta="tarjeta"
                        class="mt-3 cursor-move"></task-card>
                    <!-- </transition-group> -->
                    <!-- </draggable> -->
                </div>
            </div>
            <div class="flex" style="margin-top: 60px">
                <div id="create">
                    <v-speed-dial v-model="fab" :top="true" :bottom="false" :right="true" :left="false" direction="top"
                        :open-on-hover="false" transition="scale">
                        <template v-slot:activator>
                            <v-btn v-model="fab" color="primary" dark fab class="flotantebtn" style="opacity: 0.6">
                                <v-icon v-if="fab">
                                    mdi-close
                                </v-icon>
                                <v-icon v-else>
                                    mdi-apps
                                </v-icon>
                            </v-btn>
                        </template>
                        <v-btn fab title="Descargar Excel" dark small color="green" class="flotantebtnmenu"
                            @click="DescargaExcel()" :loading="loadingExcel" style="opacity: 0.7">
                            <v-icon>mdi-file-excel</v-icon>
                        </v-btn>
                    </v-speed-dial>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import draggable from "vuedraggable";
import TaskCard from "@/components/pages/operacion/tableroDB/TarjetaDB.vue";
import { dragscroll } from "vue-dragscroll";
import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
import Archivos from '@/services/Archivos/Archivos.service.js';

export default {
    //props: ["busqueda"],
    components: {
        TaskCard,
        draggable,
    },
    directives: {
        dragscroll,
    },
    data() {
        return {
            columnas: [],
            tarjetas: [],
            numTarjetas: [],
            tablero: [],
            scroll: true,
            Total: 0,

            proceso: 0,
            PTabNombre: '',
            relevancia: '',
            tipovehdet: null,
            aiclave: '',
            seccion: '',
            busqueda: {
                proceso: '',
                aseguradora: '',
                flotilla: '',
                estado: '',
                gerencia: '',
                supervisoria: '',
                abogado: '',
                relevancia: '',
                perfil: ''

            },
            overlay: false,
            fab: false,
            loadingExcel: false
        };
    },
    computed: {
        ...mapState(["domain", "theme"]),
        ...mapState("Operacion", ["key"]),
    },

    methods: {
        async obtenerColumnas() {
            var formData = new FormData();
            formData.append("clave", this.proceso);
            let response = await this.axios.post(
                `${this.domain.domainNameForApi}Dashboard/Encabezado`,
                formData
            );
            this.columnas = response.data.sort((a, b) => a.Orden - b.Orden);
        },
        async obtenerTarjetas() {
            var formData = new FormData();

            formData.append("data", JSON.stringify([this.busqueda]));
            let response = await this.axios.post(`${this.domain.domainNameForApi}Dashboard/Tarjetas`, formData);
            this.tarjetas = response.data;
        },
        async obtenerTotalTarjetas() {
            var formData = new FormData();
            formData.append("data", JSON.stringify([this.busqueda]));
            let response = await this.axios.post(
                `${this.domain.domainNameForApi}Dashboard/TotalTarjetas`,
                formData
            );

            this.numTarjetas = response.data;
            let sum = 0;
            this.Total = response.data.reduce((sum, item) => { return sum + item.Total }, 0);
        },
        obtenerTotal(id) {

            var find = this.numTarjetas.filter((item) => item.ClaveCol == id);
            return find.length == 0 ? 0 : find[0].Total;
        },
        bgStyle: function (color) {
            const [r, g, b] = color;
            return {
                backgroundColor: `rgba(${r},${g},${b}, 0.2)`,
            };
        },
        async DescargaExcel() {
            this.loadingExcel = true;
            var formData = new FormData();
            formData.append("data", JSON.stringify([this.busqueda]));
            let response = await this.axios.post(`${this.domain.domainNameForApi}Dashboard/ObtenerTarjetas_DescargaExcel`, formData);
            let today = moment().format('yyyy-MM-DD');
            let nombreArchivo = 'ReportesDashboard-' + today.toString();
            await MetodosGenerales.exportToExcel(response.data, nombreArchivo, true, false);

            this.loadingExcel = false;

            var formData = new FormData();
            formData.append("lasitio", 'Prusia+');
            formData.append("lomodulo", 'Dashboard');
            formData.append("laaccion", "Descargar Archivo excel");
            formData.append("lacaracteristicas", 'Reportes Dashboard');
            formData.append("lanombre", nombreArchivo + ".xlsx");
            formData.append("ladestinatario", " ");
            Archivos.AlmacenarVisitas(formData).then(data => {
            });
        }
    },
    async mounted() {
        this.overlay = true;
        if (window.sessionStorage.getItem("BusquedaFiltrox") != null) {
            let busquedas = await MetodosGenerales.obtenerSessionReporte("BusquedaFiltrox");
            this.busqueda = [];
            this.busqueda = busquedas;
            this.proceso = busquedas.proceso.PTabClave;
            this.seccion = busquedas.seccion;
            this.relevancia = busquedas.relevancia;
            this.tipovehdet = busquedas.vehDetTipo;
            if (this.proceso === undefined) {
                this.$router.push({ name: 'index' });
            }
            else {
                if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                    this.scroll = false;
                } else {
                    this.scroll = true;
                }
                await this.obtenerColumnas();
                await this.obtenerTarjetas();
                await this.obtenerTotalTarjetas();
                this.columnas.forEach((element) => {
                    this.tablero.push({
                        idColumna: element.ClaveCol,
                        encabezado: element.Titulo,
                        tarjeta: this.tarjetas.filter(
                            (item) => item.ClaveCol == element.ClaveCol
                        ),
                    });
                });
                if (this.columnas.length == this.tablero.length) {
                    this.overlay = false;
                    //setTimeout(() => {
                    //    document.getElementById("cargando").style.opacity = 0;
                    //    setTimeout(() => {
                    //        document.getElementById("cargando").style.display = "none";
                    //    }, 2000);
                    //}, 1000);
                }
            }

        }
        else {
            this.$router.push({ name: `Dashboard` });
        }
    },
};
</script>

<style lang="scss">
.column-width {
    min-width: 320px;
    width: 320px;
}

/* Unfortunately @apply cannot be setup in codesandbox, 
but you'd use "@apply border opacity-50 border-blue-500 bg-gray-200" here */
.ghost-card {
    opacity: 0.5;
    background: #f7fafc;
    border: 1px solid #4299e1;
}

//Loading
.loader {
    border-top-color: #3498db;
    -webkit-animation: spinner 1.5s linear infinite;
    animation: spinner 1.5s linear infinite;
}

@-webkit-keyframes spinner {
    0% {
        -webkit-transform: rotate(0deg);
    }

    100% {
        -webkit-transform: rotate(360deg);
    }
}

@keyframes spinner {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.opacity-75 {
    transition: opacity 2s linear;
    width: 40px;
    height: 40px;
    opacity: 0.75;
}

#create .v-btn {
    position: fixed;
}

.flotantebtn {
    top: 500px;
    position: fixed;
    right: 10px;
}

.flotantebtnmenu {
    top: 440px;
    position: fixed;
    right: 10px;
}
</style>
